export const paymDocTableColumnLabels = {
    f_sales_user_name: "ID użytkownika",
    f_paym_doc_c_who: "Strona płatności",
    f_paym_doc_c_typ_desc: "Typ dowodu kas.",
    f_paym_doc_num: "Numer dokumentu",
    f_paym_doc_dat: "Data dokumentu",
    f_paym_doc_gross_mnt: "Kwota brutto",
    f_paym_doc_comment: "Uwagi",
} as const;

export type PaymDocTableColumnKey = keyof typeof paymDocTableColumnLabels;
